<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      succeed: null,
      targetUrl: null,
      paymentId: null,
    };
  },
  created() {
    this.succeed = this.$route.query.succeed == 'true' ? true : false;
    this.targetUrl = this.$route.query.targetUrl;
    this.paymentId = this.$route.query.paymentId;
    let targetUrlArray = this.targetUrl.split('?');
    let stringUrl = this.targetUrl;

    if (targetUrlArray.length > 1) {
      stringUrl += '&succeed=' + this.$route.query.succeed;
    } else {
      stringUrl += '?succeed=' + this.$route.query.succeed;
    }
    if (this.paymentId) {
      stringUrl = stringUrl + '&paymentId=' + this.paymentId;
    }
    this.$router.replace(stringUrl);
  },
};
</script>

<style scoped lang="scss"></style>
